import { render, staticRenderFns } from "./talentDialog.vue?vue&type=template&id=4ec77108&scoped=true&"
import script from "./talentDialog.vue?vue&type=script&lang=js&"
export * from "./talentDialog.vue?vue&type=script&lang=js&"
import style0 from "./talentDialog.vue?vue&type=style&index=0&id=4ec77108&lang=scss&scoped=true&"
import style1 from "./talentDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec77108",
  null
  
)

export default component.exports